import { ptBR } from './ptBR'
import { en } from './en'
import { es } from './es'

export default {
  pt: ptBR,
  en: en,
  es: es
}
